import packageJson from '../package.json'

const versionInfo = {
  version: packageJson.version,
  sdkVersion: '3',
}

export default versionInfo
